/* eslint import/no-extraneous-dependencies: 0 */
/* eslint no-underscore-dangle: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';

// AI_bluethooth_control tiene un input de sentencias por clase del modelo de ML. Se serializa con
// saveExtraState/loadExtraState: en JSON mutationToDom/domToMutation no se llaman y el bloque
// reabriría sin clases, perdiendo lo conectado.

// Sin modelo cargado no hay clases y el bloque queda solo con el encabezado, igual que en prod.
const clasesDeML = () => {
  const ws = Blockly.getMainWorkspace();

  return (ws && typeof ws.getMLClasses === 'function') ? ws.getMLClasses() : [];
};

Blockly.Blocks.AI_bluethooth_control = {
  init: function () {
    this.AIclasses = clasesDeML();
    this.classesCount_ = this.AIclasses.length;
    this.setColour(colors.COLOUR_ML);
    this.appendDummyInput('PIN')
      .appendField(`${Blockly.Msg.LANG_SALIDAS_BUTTONS} IA`)
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/joystick/icon.png`, 32, 19))
      .appendField(Blockly.Msg.LANG_SALIDAS_BUTTONS_SPACE);
    this.updateShape_();
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_BUTTONS_TOOLTIP);
  },

  // Solo se guarda cuántas clases había: los nombres son del modelo, no del proyecto.
  saveExtraState: function () {
    return this.classesCount_ ? { classesCount: this.classesCount_ } : null;
  },

  loadExtraState: function (state) {
    this.classesCount_ = (state && state.classesCount) || 0;
    this.rebuildShape_();
  },

  // '--' marca clases guardadas que el modelo actual no tiene: se muestra el hueco en vez de perder
  // lo conectado.
  updateShape_: function () {
    let i = 0;
    while (this.getInput(`BUTN${i}`)) {
      this.removeInput(`BUTN${i}`);
      i += 1;
    }

    for (i = 0; i < this.classesCount_; i += 1) {
      this.appendStatementInput(`BUTN${i}`)
        .setAlign(Blockly.inputs.Align.RIGHT)
        .appendField(this.AIclasses[i] ? this.AIclasses[i][0] : '--');
    }
  },

  guardarConexiones_: function () {
    const conexiones = [];
    for (let i = 0; i < this.classesCount_; i += 1) {
      const input = this.getInput(`BUTN${i}`);
      conexiones.push(input ? input.connection.targetConnection : null);
    }

    return conexiones;
  },

  // reconnect es de la conexión en v13, no de Blockly.Mutator.
  restaurarConexiones_: function (conexiones) {
    for (let i = 0; i < this.classesCount_; i += 1) {
      const conexion = conexiones[i];
      if (conexion && this.getInput(`BUTN${i}`)) {
        conexion.reconnect(this, `BUTN${i}`);
      }
    }
  },

  rebuildShape_: function () {
    const conexiones = this.guardarConexiones_();
    this.updateShape_();
    this.restaurarConexiones_(conexiones);
  },

  // La llama el workspace cuando cambian las clases del modelo. Los eventos se agrupan para que el
  // cambio sea un solo paso de undo.
  updateClassNames: function () {
    const conexiones = this.guardarConexiones_();
    const anterior = this.classesCount_;

    Blockly.Events.setGroup(true);
    try {
      this.AIclasses = clasesDeML();
      this.classesCount_ = this.AIclasses.length;
      this.updateShape_();
      this.restaurarConexiones_(conexiones);

      if (anterior !== this.classesCount_) {
        Blockly.Events.fire(new Blockly.Events.BlockChange(
          this, 'mutation', null,
          JSON.stringify({ classesCount: anterior }),
          JSON.stringify({ classesCount: this.classesCount_ }),
        ));
      }
    } finally {
      Blockly.Events.setGroup(false);
    }

    if (this.rendered) this.queueRender();
  },
};
